@if (showEmptyState) {
  <div class="empty-state">
    <div class="image"></div>
    <div class="empty-state-message">No insights available at this time.</div>
  </div>
} @else {
  <div class="dashboard-select-form-container">
    <rkt-form [form]="dashboardSelectForm" [fields]="formFields" [model]="formModel" (modelChange)="initializeSupersetWidget()"></rkt-form>
  </div>

  <div id="dashboard" class="embedded-superset"></div>
}
